import { SVGProps } from 'react';

export const ChaptersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='22'
    height='22'
    viewBox='0 0 26 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M5.01416 16.5765V13.3912C5.01416 12.981 5.45679 12.7185 5.82382 12.911L8.86069 14.5037C9.25061 14.7082 9.25061 15.2596 8.86069 15.4641L5.82382 17.0567C5.45679 17.2492 5.01416 16.9867 5.01416 16.5765Z'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M11.5847 8.88867V21.0824'
      strokeWidth='1.19072'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M18.2175 16.2129H14.0303'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M16.4457 13.6738H14.0303'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M20.4785 11.0824V18.4236C20.4785 20.1495 19.0635 21.5517 17.3085 21.5517H5.39403C3.64335 21.5517 2.22412 20.1512 2.22412 18.4236V11.55C2.22412 9.82241 3.64335 8.42188 5.39403 8.42188H17.7824C19.2715 8.42188 20.4785 9.61303 20.4785 11.0824Z'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
    />
    <path
      d='M23.7758 7.37063V14.3183C23.7758 16.0426 22.3593 17.4404 20.612 17.4404H20.4784V11.082C20.4784 9.61265 19.2713 8.4215 17.7824 8.4215H5.52148V7.4387C5.52148 5.71109 6.94072 4.31055 8.6914 4.31055H20.6749C22.3875 4.31055 23.7758 5.68058 23.7758 7.37063Z'
      strokeWidth='1.39655'
      strokeMiterlimit='10'
    />
    <path
      d='M14.8796 8.42184V4.77832'
      strokeWidth='1.19072'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);
